import * as actionTypes from '../actions/actionTypes';


const INITIAL_STATE = {
    loading: false,
    flexObjects: {
        flexMulti: {},
        advSearchObj: {},
        searchedFlexList: [],
        flexUpload: {},
        flexClips: []
    }
};

const FlexReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.FLEX_UPDATE_FLEXOBJECTS:
            return {
                loading: true
            }
        case actionTypes.FLEX_UPDATE_FLEXOBJECTS_SUCCESS:
            return {
                loading: false,
                flexObjects: { ...state.flexObjects, ...action.payload }
            }
        case actionTypes.FLEX_SET_INITIAL_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default FlexReducer;